var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('h2',[_vm._v("ID: "+_vm._s(_vm.$route.query.id))]),_c('Button',{on:{"click":_vm.close}},[_vm._v("调用closeTag方法关闭本页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }